import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from 'posthog-js/react';
import "./index.css";
import App from "./App";
import reducers from "./store/reducers";
import "./sass/main.scss";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk))
);

const options = {
  api_host: 'https://eu.i.posthog.com',
};

ReactDOM.render(
  <PostHogProvider
    apiKey="phc_agmiLwOXr7dtJvTnf9EuG5us1XoysPRPMmvbsDmLiLj"
    options={options}
  >
    <Provider store={store}>
      <BrowserRouter>
        <App minimumLoadingTime={1000} />
      </BrowserRouter>
    </Provider>
  </PostHogProvider>,
  document.getElementById("root")
);


export default store;
